// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + chunkId + ".js?v=" + {"640":"b2fa23a809053c6305c5","5771":"a4e2a98efcfb7393c5bd","5810":"e0ecfcd31fb108c51bfd","7432":"1f201e1e5efef3bbb343"}[chunkId] + "";
};